import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function CreateServiceReviewSubmissionsFormFields() {
  return (
    <>
      <ParentBlockSelectField
        fieldName="config.payload"
        label="ServiceReviewSubmissions Source"
        helperText={getSourceBlockNameHelperText('ServiceReviewSubmissions')}
      />
      <ParentBlockSelectField
        fieldName="config.order.sourceBlockName"
        label="Order Source"
        required
        helperText={getSourceBlockNameHelperText('Order')}
      />
    </>
  );
}
